import { createSlice } from '@reduxjs/toolkit';

const countriesSlice = createSlice({
    name: 'countries',
    initialState: {
        value: "Sweden",
    },
    reducers: {
        updateCountry: (state, action) => {
            return action.payload;
        },
        removeCountry: (state) => {
            state.value = "";
        }
    }
});

export const { updateCountry, removeCountry } = countriesSlice.actions;

export const selectCountry = (state) => state.countries.value;

export default countriesSlice.reducer;
